module.exports = __webpack_public_path__ + "img/pic.1238a5ea.png";